import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppPropertyBasicModel, HxStoreService, StoreFullModel } from 'hx-services';
import { ActivatedRoute, Data, Router } from '@angular/router';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslocoDirective, TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { Subject } from 'rxjs';
import { NotificationService } from '@adm-web-app/services/notification.service';
import { NzAffixComponent } from 'ng-zorro-antd/affix';
import { HxBreadcrumbsComponent } from '@adm-web-app/components/breadcrumbs/breadcrumbs.component';
import { NzPageHeaderComponent, NzPageHeaderTitleDirective } from 'ng-zorro-antd/page-header';
import { NzSpinComponent } from 'ng-zorro-antd/spin';
import { NzFormControlComponent, NzFormDirective, NzFormItemComponent, NzFormLabelComponent } from 'ng-zorro-antd/form';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import { NzOptionComponent, NzSelectComponent } from 'ng-zorro-antd/select';
import { NgFor, NgIf } from '@angular/common';
import { NzRadioComponent, NzRadioGroupComponent } from 'ng-zorro-antd/radio';
import { NzInputDirective } from 'ng-zorro-antd/input';
import { StoreInfoFormComponent } from '../store-info-form/store-info-form.component';
import { NzAlertComponent } from 'ng-zorro-antd/alert';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { NzWaveDirective } from 'ng-zorro-antd/core/wave';

import { NzIconDirective } from 'ng-zorro-antd/icon';
import { NzTagComponent } from 'ng-zorro-antd/tag';

interface PropertyFormModel {
  enabled: boolean;
  key: string;
  value: string;
}

@Component({
    selector: 'hc-store-property-edit',
    templateUrl: './edit.component.html',
    styleUrls: ['./edit.component.less'],
  imports: [NzAffixComponent, HxBreadcrumbsComponent, NzPageHeaderComponent, NzPageHeaderTitleDirective, NzSpinComponent, TranslocoDirective, FormsModule, NzFormDirective, ReactiveFormsModule, NzRowDirective, NzColDirective, NzFormItemComponent, NzFormLabelComponent, NzSelectComponent, NgFor, NzOptionComponent, NzFormControlComponent, NzRadioGroupComponent, NzRadioComponent, NzInputDirective, NgIf, StoreInfoFormComponent, NzAlertComponent, NzButtonComponent, NzWaveDirective, NzIconDirective, NzTagComponent, TranslocoPipe]
})
export class StorePropertyEditComponent implements OnInit, OnDestroy {

  prop?: AppPropertyBasicModel;
  isEdit = false;
  isCreate = false;
  isSaving = false;
  allKeys = [
    {title: 'store-info'},
    {title: 'discardProduct'},
    {title: 'child'},
    {title: 'fiscalization'},
    {title: 'storage-invoice-file'},
    {title: 'payment-approval'},
    {title: 'invoiceContract'},
  ];
  store!: StoreFullModel;
  form = new FormGroup({
    enabled: new FormControl<boolean | null>(null, Validators.required),
    key: new FormControl<string | null>(null, Validators.required),
    value: new FormControl<string | null>(null, Validators.required),
  });

  private $destroyed = new Subject<void>();

  constructor(
    private aRoute: ActivatedRoute,
    private storeService: HxStoreService,
    private tr: TranslocoService,
    private nt: NotificationService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    const routeData: Data = this.aRoute.snapshot.data;
    this.store = routeData['store'] as StoreFullModel;
    this.prop = routeData['property'] as AppPropertyBasicModel;
    if (this.prop) {
      this.isEdit = true;
      this.form.controls.key.disable();
    } else {
      this.isCreate = true;
    }
    this.form.patchValue({
      enabled: this.prop.enabled,
      key: this.prop.key,
      value: this.prop.value ? JSON.stringify(this.prop.value) : ''
    });
  }

  async submitForm() {
    Object.values(this.form.controls).forEach(ctrl => {
      ctrl.markAsDirty();
      ctrl.updateValueAndValidity();
    });
    if (this.form.valid) {
      const formModel = this.form.getRawValue();
      if (!formModel.value || formModel.enabled === null || formModel.enabled === undefined || !formModel.key) {
        throw new Error('required.fields');
      }
      this.isSaving = true;
      try {
        await this.storeService.saveProperty(this.store.id, {
          enabled: formModel.enabled,
          key: formModel.key,
          value: JSON.parse(formModel.value),
        });
        this.form.markAsPristine();
        this.nt.success('stores.property.title', 'nt.dataSaved');
        if (this.isCreate) {
          this.router.navigate([`/stores/${this.store.id}/properties/${formModel.key}/edit`]);
        }
      } finally {
        this.isSaving = false;
      }
    } else {
      console.log('not valid form');
    }
  }

  ngOnDestroy(): void {
    this.$destroyed.next();
    this.$destroyed.complete();
  }


  onFormChanged(event: string) {
    this.form.patchValue({
      value: event
    });
    this.form.markAsDirty();
  }
}
